export enum DmBriefCloseReason {
    PROJECT_CANCELLED,
    ALREADY_HIRED_BRIEF,
    HIRED_ELSEWHERE_IN_FIVERR,
    FREELANCERS_NOT_MET_REQUIREMENTS,
    HIRED_OUTSIDE_FIVERR,
    DELETED_BRIEF,
    OTHER,
}

export enum CloseAction {
    MARK_AS_DONE = 'mark_as_done',
    SET_TO_INACTIVE = 'set_to_inactive',
    DELETE_BRIEF = 'delete_brief',
}
